export const ERROR = {
  INVALID_NUMBER: 'INVALID_NUMBER',
  UNABLE_TO_VALIDATE: 'UNABLE_TO_VALIDATE',
};
